import React, { Component } from 'react';
import {
  TextField
} from 'react-admin';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import EjectedDatagrid from '../../../components/ejected/Datagrid';
import EjectedSelectField from '../../../components/ejected/SelectField';
import {
  COMPANY_STATUS_NEW, CALLCENTER_STATUS_NEW, CALLCENTER_PLAN
} from '../../../common';


const segmentStyles = {
  main: { display: 'flex', flexWrap: 'wrap' },
  chip: { margin: 4 },
};

class ChipStatus extends Component {
  render() {
    return (
      <div style={{
        position: 'relative',
        right: '-8px',
        top: '1px',
        width: '10px',
        height: '10px',
        background: this.props.color
      }}
      />
    );
  }
}

const CompaniesField = ({ record, companies }) => (
  <span style={segmentStyles.main}>
    {record.companies_list && record.companies_list.map(companyId => {
      const company = companies.find(s => s.id === companyId);
      const label = company ? company.name : 'none';
      const statusnew = company ? company.statusnew : 'enabled';
      const color = COMPANY_STATUS_NEW.find(obj => {
        return obj.id === statusnew;
      }).color;
      return (
        <Chip
          key={companyId}
          style={segmentStyles.chip}
          label={label}
          avatar={<ChipStatus color={color} />}
        />
      );
    })}
  </span>
);

CompaniesField.defaultProps = {
  addLabel: true,
  source: 'companies_list',
};

const Datagrid = ({
  create, edit, total, companies, roles, ...rest
}) => (
  <EjectedDatagrid
    currentSort={{ order: 'ASC', field: 'name' }}
    create={create}
    edit={edit}
    {...rest}
  >
    <TextField source="name" label="Название" customstyles={{ width: '100px', backgroundColor: '#2c9bc3' }} />
    <TextField source="shortName" label="Абр." customstyles={{ width: '42px'}} />
    <CompaniesField companies={companies} label="Юр.Компании" />
    <TextField source="notfired" label="Акт." customstyles={{ width: '50px' }} />
    <TextField source="fired" label="Увол." customstyles={{ width: '50px' }} />
    <EjectedSelectField
      source="statusnew"
      label="Статус"
      choices={CALLCENTER_STATUS_NEW}
      optionText="shortName"
      customstyles={{
        background: '#cd9b4a',
        width: '70px',
      }}
    />
    <EjectedSelectField
      source="plan"
      label="Тип"
      choices={CALLCENTER_PLAN}
      optionText="shortName"
      customstyles={{
        background: '#cdc851',
        width: '90px',
      }}
    />
  </EjectedDatagrid>
);

Datagrid.defaultProps = {
  edit: null,
  create: null,
  companies: []
};

Datagrid.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
  companies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }))
};

export default Datagrid;



// WEBPACK FOOTER //
// ./src/pages/admin/callcenter/Datagrid.js